import { Box, IconButton, styled } from '@mui/material';

export const RouteInputContainer = styled(Box)(({ theme }) => ({
	display: 'flex',
	flexDirection: 'column',
	gap: 4,
	backgroundColor: theme.palette.common.white,
	borderRadius: 12,
	padding: '14px 12px',
	boxShadow: '6px 9px 28px 0px rgba(14, 28, 91, 0.1)',
}));

export const LocationRow = styled(Box)({
	display: 'flex',
	alignItems: 'center',
	gap: 4,
	height: 21,
	cursor: 'pointer',
	paddingRight: 36,
});

export const ConnectorSection = styled(Box)({
	display: 'flex',
	alignItems: 'center',
	height: 24,
	position: 'relative',
});

export const DashedLineContainer = styled(Box)({
	width: 16,
	height: '100%',
	display: 'flex',
	justifyContent: 'center',
	flexShrink: 0,
});

export const DashedLine = styled(Box)(({ theme }) => ({
	width: 0,
	height: '100%',
	borderLeft: `1px dashed ${theme.palette.solutions?.[600]}`,
}));

export const HorizontalSeparator = styled(Box)(({ theme }) => ({
	flex: 1,
	marginLeft: 4,
	borderBottom: `0.5px solid ${theme.palette.solutions?.[600]}`,
}));

export const SwapButton = styled(IconButton)(({ theme }) => ({
	marginLeft: 12,
	padding: 0,
	color: theme.palette.primary.main,
}));
